import { render } from "./NewsCategoryEdit.vue?vue&type=template&id=b0e664c2&scoped=true"
import script from "./NewsCategoryEdit.vue?vue&type=script&lang=js"
export * from "./NewsCategoryEdit.vue?vue&type=script&lang=js"

import "./NewsCategoryEdit.vue?vue&type=style&index=0&id=b0e664c2&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0e664c2"]])

export default __exports__